//Select One Data

import React, { useState } from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import './MyCalendar.css'; // Import your custom CSS file
 
const MyCalendar = () => {
    const [date, setDate] = useState(new Date());
 
    const handleDateChange = (newDate) => {
        setDate(newDate);
        // Handle event fetching or displaying for the selected date
    };
 
    // Dates to highlight
    const highlightDates = ['2024-11-30', '2024-11-28'].map(date => new Date(date));
 
    // Function to apply custom class to highlighted dates
    const tileClassName = ({ date }) => {
        return highlightDates.some(highlightDate => 
            date.toDateString() === highlightDate.toDateString()
        ) ? 'highlight' : null;
    };
 
    return (
        <div>
            <h2>Select a Date</h2>
            <Calendar 
                onChange={handleDateChange} 
                value={date} 
                tileClassName={tileClassName} // Apply custom class
            />
            <p>Selected Date: {date.toDateString()}</p>
            {/* Display events for the selected date here */}
        </div>
    );
};
 
export default MyCalendar;